function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import mergeRefs from '../utilities/mergeRefs';
import useButtonAnalytics from './useButtonAnalytics';
export var Button = function Button(props) {
  var analytics = props.analytics,
      analyticsLabelOverride = props.analyticsLabelOverride,
      analyticsEventTypeOverride = props.analyticsEventTypeOverride,
      analyticsParentHeading = props.analyticsParentHeading,
      analyticsParentType = props.analyticsParentType,
      onAnalyticsEvent = props.onAnalyticsEvent,
      children = props.children,
      className = props.className,
      inputRef = props.inputRef,
      isAlternate = props.isAlternate,
      onClick = props.onClick,
      onDark = props.onDark,
      size = props.size,
      variation = props.variation,
      otherProps = _objectWithoutProperties(props, ["analytics", "analyticsLabelOverride", "analyticsEventTypeOverride", "analyticsParentHeading", "analyticsParentType", "onAnalyticsEvent", "children", "className", "inputRef", "isAlternate", "onClick", "onDark", "size", "variation"]);

  var _useButtonAnalytics = useButtonAnalytics(props),
      contentRef = _useButtonAnalytics.contentRef,
      sendButtonEvent = _useButtonAnalytics.sendButtonEvent;

  var ComponentType = props.href ? 'a' : 'button';
  var colorSchemeClass = isAlternate && "ds-c-button--alternate";
  var modeClass = onDark && "ds-c-button--on-dark";
  var sizeClass = size && "ds-c-button--".concat(size);
  var variationClass = variation && "ds-c-button--".concat(variation);
  var allClassNames = classNames('ds-c-button', colorSchemeClass, modeClass, sizeClass, variationClass, className);

  var attrs = _objectSpread(_objectSpread({}, otherProps), {}, {
    className: allClassNames
  });

  if (ComponentType !== 'button') {
    delete attrs.disabled;
    delete attrs.type;

    if (props.disabled) {
      attrs.role = 'link';
      attrs['aria-disabled'] = true;
      delete attrs.href;
    }
  }

  function handleClick(e) {
    if (!props.disabled) {
      sendButtonEvent();

      if (onClick) {
        onClick(e);
      }
    }
  }

  function handleKeyPress(e) {
    // Trigger onClick on space key event for `<a>` elements
    if (e.key === ' ') {
      handleClick(e);
    }
  }

  return /*#__PURE__*/React.createElement(ComponentType, _extends({
    ref: mergeRefs([inputRef, contentRef]),
    onClick: handleClick,
    onKeyPress: ComponentType === 'a' ? handleKeyPress : undefined
  }, attrs), children);
};
Button.defaultProps = {
  isAlternate: false,
  onDark: false,
  type: 'button'
};
export default Button;